import { useTranslation } from '@edreamsodigeo/frontend-core';

import { useCampaignSuffix } from '~clientState/hooks';
import type { CampaignSuffix } from '~clientState/hooks/useCampaignSuffix/useCampaignSuffix';

type CampaignSwitchingSuffix =
  | `_campaign.${CampaignSuffix}`
  | '_campaign.default';

const useCampaignTranslate = (debugCampaign?: CampaignSuffix) => {
  const { t } = useTranslation();
  const campaignSuffix: CampaignSuffix = useCampaignSuffix();
  const campaignSwitchingSuffix: CampaignSwitchingSuffix = campaignSuffix
    ? `_campaign.${debugCampaign || campaignSuffix}`
    : '_campaign.default';

  const translateWithCampaign = (
    baseKeyName: string,
    variables?: Parameters<ReturnType<typeof useTranslation>['t']>[1]
  ): string => t(baseKeyName + campaignSwitchingSuffix, variables);

  const getKeyWithCampaign = (baseKeyName: string): string => {
    return baseKeyName + campaignSwitchingSuffix;
  };

  return { translateWithCampaign, getKeyWithCampaign };
};

export default useCampaignTranslate;
